import { Link } from "react-router-dom";
import { LogoMark } from "./Logo";
import { PoweredByPybricks } from "./PoweredByPybricks";

export const Footer = () => (
  <footer className="no-print border-t">
    <div className="mx-auto grid max-w-7xl gap-8 px-4 py-12 sm:px-8 md:grid-cols-[1.4fr_1fr_1fr]">
      <div className="space-y-3">
        <div className="flex items-center gap-2.5">
          <LogoMark className="h-7 w-7" />
          <span className="font-display text-lg font-extrabold">HubPilot.au</span>
        </div>
        <p className="max-w-md text-sm text-muted-foreground">
          The easiest way to set up LEGO® Education SPIKE™ Prime robots and drive them with Xbox® wireless controllers. Free for every student, forever.
        </p>
        <PoweredByPybricks testId="footer-pybricks" />
      </div>
      <div className="space-y-2 text-sm">
        <p className="eyebrow text-muted-foreground">Guides</p>
        <Link className="block hover:text-primary" to="/firmware" data-testid="footer-firmware-link">Firmware setup</Link>
        <Link className="block hover:text-primary" to="/how-it-works" data-testid="footer-how-link">How it works</Link>
        <Link className="block hover:text-primary" to="/compatibility" data-testid="footer-compatibility-link">Compatibility</Link>
      </div>
      <div className="space-y-3 text-xs leading-relaxed text-muted-foreground">
        <p data-testid="footer-pybricks-credit">
          {"HubPilot is built as part of the "}
          <a href="https://www.creatoracademy.edu.au" target="_blank" rel="noreferrer" className="mx-0.5 font-semibold text-foreground underline decoration-primary/50 underline-offset-2 hover:text-primary" data-testid="footer-credit-creator-academy-link">Creator Academy</a>
          {" CodePlay™ system. It isn't made, sponsored or endorsed by Pybricks. Robots run on the official Pybricks firmware, which you install yourself from code.pybricks.com. Pybricks is © The Pybricks Authors."}
        </p>
        <p data-testid="footer-trademarks">
          LEGO®, SPIKE™ and MINDSTORMS® are trademarks of the LEGO Group, which does not sponsor, authorise or endorse this site. Xbox® is a registered trademark of Microsoft Corporation, which is not affiliated with HubPilot.
        </p>
      </div>
    </div>
    <div className="border-t">
      <p className="mx-auto max-w-7xl px-4 py-5 text-sm text-muted-foreground sm:px-8" data-testid="footer-codeplay">
        {"Part of the "}
        <a href="https://www.creatoracademy.edu.au" target="_blank" rel="noreferrer" className="mx-0.5 font-semibold text-foreground underline decoration-primary/50 underline-offset-4 hover:text-primary" data-testid="footer-creator-academy-link">Creator Academy</a>
        {" CodePlay™ system"}
      </p>
    </div>
  </footer>
);
